var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: {
            "default-active": _vm.$route.path,
            mode: "horizontal",
            "background-color": "#545c64",
            "text-color": "#fff",
            "active-text-color": "#409EFF",
            router: ""
          }
        },
        [
          _c(
            "el-menu-item",
            { attrs: { index: "/home/wavepicking/wavepickinglist" } },
            [_vm._v("波次单列表")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            { attrs: { index: "/home/aswavepicking/aswavepickinglist" } },
            [_vm._v("售后波次")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            { attrs: { index: "/home/wavepicking/TempSummaryList/5" } },
            [_vm._v("质检汇总")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            { attrs: { index: "/home/wavepicking/TempSummaryList/6" } },
            [_vm._v("改标汇总")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            {
              attrs: { index: "/home/surpassSummary/surpassSummaryPickingList" }
            },
            [_vm._v("中分汇总拣货")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "波次号" },
                                        model: {
                                          value: _vm.search_type,
                                          callback: function($$v) {
                                            _vm.search_type = $$v
                                          },
                                          expression: "search_type"
                                        }
                                      },
                                      _vm._l(_vm.search_options, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: {
                                      "margin-left": "-15px",
                                      width: "165px"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "请输入搜索内容" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.search_value,
                                        callback: function($$v) {
                                          _vm.search_value = $$v
                                        },
                                        expression: "search_value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: { placeholder: "请选择状态" },
                                        model: {
                                          value: _vm.form.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "status", $$v)
                                          },
                                          expression: "form.status"
                                        }
                                      },
                                      _vm._l(_vm.conditionData.status, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.status_id,
                                          attrs: {
                                            label: item.status_name,
                                            value: item.status_id
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: {
                                          placeholder: "请选择波次类型"
                                        },
                                        model: {
                                          value: _vm.form.type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "type", $$v)
                                          },
                                          expression: "form.type"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.conditionData.as_type,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.type_id,
                                              attrs: {
                                                label: item.type_name,
                                                value: item.type_id
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: {
                                          placeholder: "是否生成拣货任务"
                                        },
                                        model: {
                                          value:
                                            _vm.form.is_generate_picking_task,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "is_generate_picking_task",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.is_generate_picking_task"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-option",
                                          { attrs: { value: "" } },
                                          [_vm._v("全部")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.conditionData
                                            .generate_picking_task,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.value,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "150px" },
                                        attrs: {
                                          multiple: "",
                                          placeholder: "有无备注"
                                        },
                                        model: {
                                          value: _vm.form.is_remark,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "is_remark", $$v)
                                          },
                                          expression: "form.is_remark"
                                        }
                                      },
                                      _vm._l(_vm.remarks, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "500px" },
                                    attrs: { label: "波次时间：" }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "default-time": ["06:00:00", "06:00:00"]
                                      },
                                      model: {
                                        value: _vm.form.create_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "create_time", $$v)
                                        },
                                        expression: "form.create_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          "background-color": "#e1e1e1"
                                        },
                                        on: { click: _vm.resetCondition }
                                      },
                                      [_vm._v("重置")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("\n                    查询波次")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: {
                                          click: function($event) {
                                            _vm.show_statistics = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    统计数据查看"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.is_show_search_option = !_vm.is_show_search_option
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-arrow-down"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.is_show_search_option
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "选择快递公司"
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.shipping_company,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "shipping_company",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.shipping_company"
                                                }
                                              },
                                              _vm._l(
                                                _vm.conditionData.express,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item,
                                                    attrs: {
                                                      label: item,
                                                      value: item
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "是否拦截"
                                                },
                                                model: {
                                                  value:
                                                    _vm.form.is_stop_shipping,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "is_stop_shipping",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.is_stop_shipping"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-option",
                                                  { attrs: { value: "" } },
                                                  [_vm._v("全部")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.conditionData
                                                    .is_stop_shipping,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.id,
                                                      attrs: {
                                                        label: item.name,
                                                        value: item.id
                                                      }
                                                    })
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  placeholder: "是否配齐"
                                                },
                                                model: {
                                                  value: _vm.form.full_allot,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "full_allot",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.full_allot"
                                                }
                                              },
                                              _vm._l(_vm.is_pq, function(item) {
                                                return _c("el-option", {
                                                  key: item.key,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.key
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "波次待发数量" } },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "150px" },
                                              attrs: {
                                                placeholder: "波次待发数量"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.form.wave_picking_num,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "wave_picking_num",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.wave_picking_num"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "~" } },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "150px" },
                                              attrs: {
                                                placeholder: "波次待发数量"
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.search.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.form.wave_picking_num_end,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "wave_picking_num_end",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.wave_picking_num_end"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder: "省"
                                                },
                                                on: { change: _vm.getCity },
                                                model: {
                                                  value: _vm.form.province,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "province",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.province"
                                                }
                                              },
                                              _vm._l(
                                                _vm.conditionData.province,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.region_id,
                                                    attrs: {
                                                      label: item.region_name,
                                                      value: item.region_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder: "市"
                                                },
                                                on: { change: _vm.getDistrict },
                                                model: {
                                                  value: _vm.form.city,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "city",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.city"
                                                }
                                              },
                                              _vm._l(
                                                _vm.cityData.list,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.region_id,
                                                    attrs: {
                                                      label: item.region_name,
                                                      value: item.region_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder: "区"
                                                },
                                                model: {
                                                  value: _vm.form.district,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "district",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.district"
                                                }
                                              },
                                              _vm._l(
                                                _vm.districtData.list,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.region_id,
                                                    attrs: {
                                                      label: item.region_name,
                                                      value: item.region_id
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          { attrs: { label: "出库时间：" } },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "350px" },
                                              attrs: {
                                                "default-time": [
                                                  "06:00:00",
                                                  "06:00:00"
                                                ],
                                                type: "datetimerange",
                                                "range-separator": "至",
                                                "start-placeholder": "开始日期",
                                                "end-placeholder": "结束日期"
                                              },
                                              model: {
                                                value: _vm.form.out_time,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "out_time",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.out_time"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { border: "1px solid #ddd" }, attrs: { span: 24 } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _vm._v(
                    "\n        数据汇总     波次单数量：" +
                      _vm._s(_vm.resData.total) +
                      "\n        "
                  ),
                  _vm._v(
                    "\n                波次商品待发数量：" +
                      _vm._s(_vm.resData.sku_num) +
                      "\n      "
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { border: "1px solid #ddd" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "50px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("数据列表：")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: { type: "danger", size: "mini" },
                      on: { click: _vm.mergeWavePicking }
                    },
                    [_vm._v("合并波次")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown",
                    {
                      attrs: {
                        "split-button": "",
                        type: "primary",
                        size: "mini"
                      },
                      on: {
                        click: function($event) {
                          return _vm.lockWavePicking(0)
                        },
                        command: _vm.lockWavePicking
                      }
                    },
                    [
                      _vm._v("\n          锁定波次\n          "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c("el-dropdown-item", { attrs: { command: "1" } }, [
                            _vm._v("全部锁定波次")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.generateTaskBefore }
                    },
                    [_vm._v("生成拣货任务")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "mini" },
                      on: { click: _vm.unlockWavePickingByIds }
                    },
                    [_vm._v("批量解锁")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "mini" },
                      on: { click: _vm.waybillDiscard }
                    },
                    [_vm._v("\n          取消面单")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.printWavePicking }
                    },
                    [_vm._v("\n          打印配货单")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { type: "success", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.shippingVisible = true
                        }
                      }
                    },
                    [_vm._v("修改快递公司")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "请选择快递公司",
                        visible: _vm.shippingVisible
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.shippingVisible = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-form",
                        { attrs: { model: _vm.form } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "快递公司" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择快递公司" },
                                  on: { change: _vm.getSenders },
                                  model: {
                                    value: _vm.form.express,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "express", $$v)
                                    },
                                    expression: "form.express"
                                  }
                                },
                                _vm._l(_vm.conditionData.express, function(
                                  express
                                ) {
                                  return _c("el-option", {
                                    key: express,
                                    attrs: { label: express, value: express }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.express != "物流"
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "网点" } },
                                [
                                  _vm.form.express != "物流公司"
                                    ? _c(
                                        "el-select",
                                        {
                                          attrs: { placeholder: "请选择网点" },
                                          model: {
                                            value: _vm.form.sender_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "sender_id",
                                                $$v
                                              )
                                            },
                                            expression: "form.sender_id"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: { label: "无", value: "0" }
                                          }),
                                          _vm._v(" "),
                                          _vm._l(_vm.senders, function(item) {
                                            return _c("el-option", {
                                              key: item.sender_id,
                                              attrs: {
                                                label: item.sender,
                                                value: item.sender_id
                                              }
                                            })
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.form.express == "物流"
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "物流公司" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择网点" },
                                      model: {
                                        value: _vm.form.logistics_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "logistics_id",
                                            $$v
                                          )
                                        },
                                        expression: "form.logistics_id"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "无", value: "0" }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.conditionData.logistics,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.logistics_id,
                                            attrs: {
                                              label: item.logistics_name,
                                              value: item.logistics_id
                                            }
                                          })
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer"
                        },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.shippingVisible = false
                                }
                              }
                            },
                            [_vm._v("取 消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.updateShipping(0)
                                }
                              }
                            },
                            [_vm._v("\n              确 定")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-upload",
                    {
                      staticStyle: { margin: "0 10px 2px" },
                      attrs: {
                        action: _vm.action,
                        name: "excel",
                        limit: 1,
                        "on-success": _vm.importFileWeight,
                        "file-list": _vm.fileList,
                        "auto-upload": "",
                        "with-credentials": ""
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "mini", type: "primary" } },
                        [_vm._v("导入重量")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.exportExpress }
                    },
                    [_vm._v("\n          导出电子面单")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.output }
                    },
                    [_vm._v("\n          导出波次单")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.outputInfo }
                    },
                    [_vm._v("\n          导出波次单明细")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.outputLog }
                    },
                    [_vm._v("\n          导出改排日志")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "-5px" },
                      attrs: { type: "success", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.show_log_time = !_vm.show_log_time
                        }
                      }
                    },
                    [_c("i", { staticClass: "el-icon-date" })]
                  ),
                  _vm._v(" "),
                  _vm.show_log_time == 1
                    ? _c("el-date-picker", {
                        attrs: {
                          size: "mini",
                          format: "yyyy-MM-dd HH:mm:ss",
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "default-time": ["06:00:00", "06:00:00"]
                        },
                        model: {
                          value: _vm.form.log_time,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "log_time", $$v)
                          },
                          expression: "form.log_time"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("field-setting", {
                    attrs: { page: "2" },
                    on: { onsuccess: _vm.changeFields }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.resData
                ? _c(
                    "div",
                    { staticStyle: { "margin-bottom": "0" } },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading"
                            }
                          ],
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            height: "600",
                            data: _vm.resData.data,
                            "tooltip-effect": "dark",
                            "row-class-name": _vm.tableRowClassName
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              type: "selection",
                              width: "55"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "as_wave_picking_no",
                              label: "波次号",
                              width: "120",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _vm.showFields.user_id
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "user_id",
                                  label: "用户ID",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.consignee
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "consignee",
                                  label: "收货人姓名",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_full_allot
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_full_allot",
                                  label: "是否配齐",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "as_wave_picking_type",
                              label: "波次类型",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "wave_picking_status",
                              label: "状态",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "wave_picking_is_generate_picking_task",
                              label: "是否生成拣货任务",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_mobile_hide
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_mobile_hide",
                                  label: "收货人手机",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.address
                            ? _c("el-table-column", {
                                key: "address",
                                attrs: {
                                  prop: "address",
                                  label: "收货人地址",
                                  "show-overflow-tooltip": "",
                                  align: "left",
                                  width: "200"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-edit",
                                              size: "mini",
                                              circle: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.beforeChangeAddress(
                                                  scope.row
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.address))
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  535807420
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.shipping_company
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "shipping_company",
                                  label: "快递公司",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.guarantee_value_formal
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "guarantee_value_formal",
                                  label: "是否保价",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sender",
                              label: "网点",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "shipping_type_formal",
                              label: "快递公司分配方式",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_is_put_picking_list
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_is_put_picking_list",
                                  label: "是否放置配货单",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-edit",
                                              size: "mini",
                                              circle: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.updateFields(
                                                  scope.row,
                                                  "PutList"
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row
                                                  .wave_picking_is_put_picking_list
                                              )
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2884902639
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_picking_type
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_picking_type",
                                  label: "拣货属性",
                                  "show-overflow-tooltip": "",
                                  align: "center",
                                  width: "200px"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-edit",
                                              size: "mini",
                                              circle: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.updateFields(
                                                  scope.row,
                                                  "PickingType"
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row
                                                  .wave_picking_picking_type
                                              )
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1546680708
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.shipping_num
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "shipping_num",
                                  label: "快递单号",
                                  width: "120",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_num
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_num",
                                  label: "待发总件数",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.weight
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "weight",
                                  label: "重量",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_print_status
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_print_status",
                                  label: "面单状态",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.work_id
                            ? _c("el-table-column", {
                                key: "work_id",
                                attrs: {
                                  prop: "work_id",
                                  label: "工单id",
                                  width: "180",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return _vm._l(
                                          scope.row.work_id,
                                          function(order_value, order_key) {
                                            return order_value
                                              ? _c(
                                                  "a",
                                                  {
                                                    key: order_key,
                                                    staticStyle: {
                                                      width: "160px",
                                                      margin: "0",
                                                      cursor: "pointer"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(order_key + 1) +
                                                        "." +
                                                        _vm._s(order_value)
                                                    ),
                                                    _c("br")
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        )
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2515537828
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.problem_name
                            ? _c("el-table-column", {
                                key: "problem_name",
                                attrs: {
                                  prop: "problem_name",
                                  label: "原工单问题",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return _vm.problem_name_value
                                          ? _vm._l(
                                              scope.row.problem_name,
                                              function(
                                                problem_name_value,
                                                problem_name_key
                                              ) {
                                                return _c(
                                                  "span",
                                                  { key: problem_name_key },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        problem_name_key + 1
                                                      ) +
                                                        "." +
                                                        _vm._s(
                                                          problem_name_value
                                                        )
                                                    ),
                                                    _c("br")
                                                  ]
                                                )
                                              }
                                            )
                                          : undefined
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.problem_desc
                            ? _c("el-table-column", {
                                key: "problem_desc",
                                attrs: {
                                  prop: "problem_desc",
                                  label: "问题描述",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return _vm.problem_desc_value
                                          ? _vm._l(
                                              scope.row.problem_desc,
                                              function(
                                                problem_desc_value,
                                                problem_desc_key
                                              ) {
                                                return _c(
                                                  "span",
                                                  { key: problem_desc_key },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        problem_desc_key + 1
                                                      ) +
                                                        "." +
                                                        _vm._s(
                                                          problem_desc_value
                                                        )
                                                    ),
                                                    _c("br")
                                                  ]
                                                )
                                              }
                                            )
                                          : undefined
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.service_desc
                            ? _c("el-table-column", {
                                key: "service_desc",
                                attrs: {
                                  prop: "service_desc",
                                  label: "客服备注",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return _vm._l(
                                          scope.row.service_desc,
                                          function(
                                            service_desc_value,
                                            service_desc_key
                                          ) {
                                            return service_desc_value
                                              ? _c(
                                                  "span",
                                                  { key: service_desc_key },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        service_desc_key + 1
                                                      ) +
                                                        "." +
                                                        _vm._s(
                                                          service_desc_value
                                                        )
                                                    ),
                                                    _c("br")
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        )
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4149916153
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.word_dbid_blp_note
                            ? _c("el-table-column", {
                                key: "word_bdi_blp_note",
                                attrs: {
                                  prop: "word_dbid_blp_note",
                                  label: "拆包备注",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return _vm.value
                                          ? _vm._l(
                                              scope.row.word_dbid_blp_note,
                                              function(value, key) {
                                                return _c(
                                                  "span",
                                                  { key: key },
                                                  [
                                                    _vm._v(
                                                      "[" +
                                                        _vm._s(key) +
                                                        "." +
                                                        _vm._s(value) +
                                                        "]"
                                                    ),
                                                    _c("br")
                                                  ]
                                                )
                                              }
                                            )
                                          : undefined
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.create_time
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "create_time",
                                  label: "波次时间",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.wave_picking_is_stop_shipping
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "wave_picking_is_stop_shipping",
                                  label: "是否拦截",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.update_time
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "update_time",
                                  label: "更新时间",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.sk_time
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "sk_time",
                                  label: "最近物流时间",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.sk_content
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "sk_content",
                                  label: "最近物流信息",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showFields.shipping_kdniao_state
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "shipping_kdniao_state",
                                  label: "物流状态",
                                  width: "100",
                                  align: "center"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              fixed: "right",
                              label: "操作",
                              "show-overflow-tooltip": "",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleClick(scope.row)
                                            }
                                          }
                                        },
                                        [_vm._v("查看详情")]
                                      ),
                                      scope.row.status == 4 &&
                                      scope.row.print_status != 1
                                        ? _c("br")
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == 4 &&
                                      scope.row.print_status != 1
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.reCheck(scope.row)
                                                }
                                              }
                                            },
                                            [_vm._v("重新校验")]
                                          )
                                        : _vm._e(),
                                      scope.row.print_status == 1
                                        ? _c("br")
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.print_status == 1
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#67c23a" },
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.rePrint(scope.row)
                                                }
                                              }
                                            },
                                            [_vm._v("打印面单")]
                                          )
                                        : _vm._e(),
                                      _c("br"),
                                      _vm._v(" "),
                                      scope.row.as_wave_picking_summary_id != 0
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "orange" },
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.unLockWavePicking(
                                                    scope.row.as_wave_picking_id
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("解锁波次")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.is_stop_shipping == 2
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStop(
                                                        scope.row
                                                          .wave_picking_id,
                                                        1,
                                                        scope.$index
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("拦截")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.is_stop_shipping == 1
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStop(
                                                        scope.row
                                                          .wave_picking_id,
                                                        2,
                                                        scope.$index
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("取消拦截")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2859784719
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.resData
                ? _c(
                    "div",
                    { staticStyle: { "text-align": "right", padding: "25px" } },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.curPage,
                          background: "",
                          layout: "total, prev, pager, next, jumper ",
                          total: _vm.resData.total,
                          "page-size": 100
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.curPage = $event
                          },
                          "update:current-page": function($event) {
                            _vm.curPage = $event
                          },
                          "current-change": _vm.handleCurrentChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "改排最多件",
                    visible: _vm.delVisible,
                    width: "30%",
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.delVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "改排", prop: "delNum" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: { type: "number", max: _vm.skuNum },
                              model: {
                                value: _vm.form.delNum,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "delNum", $$v)
                                },
                                expression: "form.delNum"
                              }
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v(
                                  "\n                件,最多" +
                                    _vm._s(_vm.skuNum) +
                                    "件"
                                )
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.delVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.doRearrange()
                            }
                          }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "输入修改地址",
                    visible: _vm.changeAddressVisible
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.changeAddressVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "收件人" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.form.change_consignee,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "change_consignee", $$v)
                              },
                              expression: "form.change_consignee"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "手机" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.form.change_wave_picking_mobile_hide,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "change_wave_picking_mobile_hide",
                                  $$v
                                )
                              },
                              expression: "form.change_wave_picking_mobile_hide"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "省" },
                              on: { change: _vm.getCity },
                              model: {
                                value: _vm.form.change_province,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "change_province", $$v)
                                },
                                expression: "form.change_province"
                              }
                            },
                            _vm._l(_vm.conditionData.province, function(item) {
                              return _c("el-option", {
                                key: item.region_id,
                                attrs: {
                                  label: item.region_name,
                                  value: item.region_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "市" },
                              on: { change: _vm.getDistrict },
                              model: {
                                value: _vm.form.change_city,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "change_city", $$v)
                                },
                                expression: "form.change_city"
                              }
                            },
                            _vm._l(_vm.cityData.list, function(item) {
                              return _c("el-option", {
                                key: item.region_id,
                                attrs: {
                                  label: item.region_name,
                                  value: item.region_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "区" },
                              model: {
                                value: _vm.form.change_district,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "change_district", $$v)
                                },
                                expression: "form.change_district"
                              }
                            },
                            _vm._l(_vm.districtData.list, function(item) {
                              return _c("el-option", {
                                key: item.region_id,
                                attrs: {
                                  label: item.region_name,
                                  value: item.region_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { placeholder: "详细地址" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.form.change_address,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "change_address", $$v)
                              },
                              expression: "form.change_address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { float: "left" },
                          attrs: { type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.recoveryConsignee(1)
                            }
                          }
                        },
                        [_vm._v("恢复至下单的收件信息")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.changeAddressVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.changeAddress }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.show_statistics
        ? _c(
            "div",
            [
              _c("statistics", {
                on: {
                  onCloseDialog: function($event) {
                    _vm.show_statistics = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be636732", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be636732","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/aswavepicking/AsWavePickingList.vue
// module id = null
// module chunks = 